import { render, staticRenderFns } from "./ProjectDataCenter.vue?vue&type=template&id=21fe2019&"
import script from "./ProjectDataCenter.vue?vue&type=script&lang=js&"
export * from "./ProjectDataCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports